export default __webpack_public_path__ + "static/media/you-are-here.6c80cad0.webp";